import { render } from "./ThongTin.vue?vue&type=template&id=7eff5164&scoped=true"
import script from "./ThongTin.vue?vue&type=script&lang=js"
export * from "./ThongTin.vue?vue&type=script&lang=js"

import "./ThongTin.vue?vue&type=style&index=0&id=7eff5164&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eff5164"]])

export default __exports__